module.exports = __webpack_public_path__ + "img/rnd-1.0770f613.png";